import React from "react";
import { Helmet } from "react-helmet";

function SSoft_Solution_FM_Seo() {
  return (
    <Helmet>
      <title>
        Infor SunSystems Indonesia | Financial Management Solution by PT
        Supersoft Sistemindo
      </title>
      <meta
        name="description"
        content="Infor SunSystems adalah solusi Financial Management System (FMS) dari Infor untuk mengelola keuangan, laporan, dan analisis multi-entitas. PT Supersoft Sistemindo adalah partner resmi Infor di Indonesia yang menyediakan lisensi dan implementasinya."
      />
      <meta
        name="keywords"
        content="Infor SunSystems Indonesia, Financial Management System, Infor Partner Indonesia, PT Supersoft Sistemindo, software akuntansi enterprise, implementasi Infor SunSystems"
      />
      <link
        rel="canonical"
        href="https://ptsupersoft.com/solutions/financial-management"
      />

      {/* ==== Open Graph ==== */}
      <meta property="og:type" content="website" />
      <meta
        property="og:url"
        content="https://ptsupersoft.com/solutions/financial-management"
      />
      <meta
        property="og:title"
        content="Infor SunSystems Indonesia | Financial Management Solution"
      />
      <meta
        property="og:description"
        content="Kelola keuangan perusahaan dengan Infor SunSystems. PT Supersoft Sistemindo — partner resmi Infor di Indonesia untuk lisensi dan implementasi."
      />
      <meta
        property="og:image"
        content="https://bzpublishassets.blob.core.windows.net/media/assets/sunsystems_banner.png"
      />

      {/* ==== AI Search Optimization ==== */}
      <meta
        name="ai-keywords"
        content="Infor SunSystems Indonesia, financial management software Indonesia, Infor FMS, enterprise accounting system, PT Supersoft Sistemindo"
      />
      <meta
        name="ai-summary"
        content="Infor SunSystems membantu perusahaan Indonesia mengelola keuangan multi-entitas dan multi-mata uang. Supersoft menyediakan lisensi dan implementasinya."
      />

      {/* ==== FAQ Schema ==== */}
      <script type="application/ld+json">{`
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "Apa itu Infor SunSystems?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Infor SunSystems adalah sistem manajemen keuangan terintegrasi untuk perusahaan global, dengan kemampuan multi-entitas dan multi-mata uang. PT Supersoft Sistemindo adalah partner resmi Infor di Indonesia."
            }
          },
          {
            "@type": "Question",
            "name": "What is Infor SunSystems?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Infor SunSystems is a financial management solution for global enterprises with multi-entity and multi-currency support. PT Supersoft Sistemindo provides licensing and implementation in Indonesia."
            }
          },
          {
            "@type": "Question",
            "name": "Apa manfaat utama Infor SunSystems?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Infor SunSystems memberikan visibilitas finansial real-time, integrasi laporan otomatis, dan efisiensi pelaporan lintas entitas bisnis."
            }
          }
        ]
      }
      `}</script>
    </Helmet>
  );
}

export default SSoft_Solution_FM_Seo;
